/**
 * WordPress enqueues jQuery in noConflict mode; bundled vendor scripts use `$` at load time.
 * This runs immediately before third-parties + custom in site.min.js (see gulpfile outputJS).
 */
var $ = window.jQuery;
